/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicTenableNessus extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicTenableNessus");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicTenableNessus.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicTenableNessus>): BackgroundJobPayloadForPeriodicTenableNessus {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicTenableNessus(), model);
        BackgroundJobPayloadForPeriodicTenableNessus.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicTenableNessus>): BackgroundJobPayloadForPeriodicTenableNessus {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicTenableNessus.newInstance(<BackgroundJobPayloadForPeriodicTenableNessus> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicTenableNessus) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicTenableNessus.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicTenableNessus): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicTenableNessus.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
